import FeatureCard from "./FeatureCard";

// 3D Icon component for feature cards (from Figma assets)
const Icon3D = ({ src, alt }: { src: string; alt: string }) => (
  <div className="w-14 h-14 rounded-xl overflow-hidden shadow-sm">
    <img src={src} alt={alt} className="w-full h-full object-cover" />
  </div>
);

// Avatar group component with actual character images from Figma
const AvatarGroupWithImages = () => (
  <div className="flex items-center -space-x-3">
    {[1, 2, 3, 4, 5, 6].map(num => (
      <div
        key={num}
        className="w-10 h-10 rounded-full border border-black/8 shadow-[0px_0px_0px_1.5px_white] overflow-hidden"
      >
        <img
          src={`/images/hero/avatar-${num}.png`}
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
      </div>
    ))}
  </div>
);

// Feature data matching Figma design with actual 3D icons
const features = [
  {
    id: "chat-with-characters",
    title: "Chat with Characters",
    description: "Talk to characters in-voice to explore motives, scenes and dialogue.",
    useAvatarGroup: true,
  },
  {
    id: "chat-with-book",
    title: "Chat with a book",
    description: "Ask any question; get answers grounded in the text and your progress.",
    icon: <Icon3D src="/images/hero/icon-book-3d.png" alt="Book icon" />,
  },
  {
    id: "get-summary",
    title: "Get Summary",
    description: "Instant, spoiler-safe summaries of chapters or whole books.",
    icon: <Icon3D src="/images/hero/document-icon.png" alt="Document icon" />,
  },
  {
    id: "teach-me",
    title: "Teach Me",
    description: "Bite-size lessons and practical takeaways from each book.",
    icon: <Icon3D src="/images/hero/icon-teach-3d.png" alt="Graduation cap icon" />,
  },
  {
    id: "quiz-me",
    title: "Quiz Me",
    description: "Test recall with quick, smart quizzes that reinforce learning.",
    icon: <Icon3D src="/images/hero/icon-quiz-3d.png" alt="Question mark icon" />,
  },
  {
    id: "apply-concepts",
    title: "Apply Concepts",
    description: "Turn ideas into real actions with guided prompts and examples.",
    icon: <Icon3D src="/images/hero/icon-apply-3d.png" alt="Tools icon" />,
  },
];

export default function FeaturesSection() {
  return (
    <section className="bg-[var(--color-bg-surface)] py-24" aria-labelledby="features-heading">
      <div className="max-w-[1280px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2
            id="features-heading"
            className="text-3xl md:text-4xl font-semibold text-[var(--color-text-primary)] leading-tight tracking-[-0.72px] mb-5"
          >
            What Chatable does
          </h2>
          <p className="text-lg md:text-xl text-[var(--color-text-secondary)] leading-relaxed max-w-[768px] mx-auto">
            Connect your tools, connect your teams. With over 100 apps already available in our
            directory, your team&apos;s favorite tools are just a click away.
          </p>
        </div>

        {/* Features Grid - 3 columns on desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map(feature => (
            <FeatureCard
              key={feature.id}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              avatarGroup={feature.useAvatarGroup ? <AvatarGroupWithImages /> : undefined}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
